export enum ApiResponseStatus {
  Success,
  ClientError,
  ServerError,
}
